<template>
    <div class="a-switch">
        <Switcher
            v-model="localValue"
            :disabled="disabled"
            :true-color="trueColor"
            :true-value="trueValue"
            :false-color="falseColor"
            :false-value="falseValue"
            @on-change="onChange"
        >
            <template slot="open">
                <slot name="open" />
            </template>
            <template slot="close">
                <slot name="close" />
            </template>
        </Switcher>
    </div>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
    name: 'ASwitch',
    props: {
        value: {
            type: [String, Number, Boolean],
            default: false
        },
        /**
         * Disabled state of Switch.
         */
        disabled: {
            type: Boolean,
            default: false
        },
        /**
         * Custom the background color when turned on.
         */
        trueColor: {
            type: String,
            default: ''
        },
        /**
         * Custom the background color when turned off.
         */
        falseColor: {
            type: String,
            default: ''
        },
        /**
         * Value of the switch if it's checked.
         */
        trueValue: {
            type: [String, Number, Boolean],
            default: true
        },
        /**
         * Value of the switch if it's not checked.
         */
        falseValue: {
            type: [String, Number, Boolean],
            default: false
        }
    },
    setup(props, { emit }) {
        const localValue = computed({
            get: () => props.value,
            set: value => {
                emit('input', value);
            }
        });

        function onChange(data) {
            emit('onChange', data)
        }

        return {
            localValue,
            onChange
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />